import mutations from './logins.mutations'
import actions from './logins.actions'
import getters from './logins.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
